"use client"
import { useEffect, useRef, useState } from "react"
import NewSocialPostCard from "../Cards/Social/NewSocialPostCard"
import SocialPostSmallCard from "../Cards/Social/SocialPostSmallCard"
import SocialFeed from "../SocialFeed"
import ModalHeader from "./ModalHeader"
import {useParams, useRouter, useSearchParams} from 'next/navigation'
import Link from "next/link"
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
import { ScrollContext } from "@/providers/ScrollProvider";


import { ArrowUpButton, CommentButton, ConfirmOrCancelButton, CopyUrlButton, EditButton, MultipurposeOvalButton, RoundButton } from "@/components/Atoms/Buttons/ColorButtons"
import ShareModal from "./ShareModal"





//  Recursive component for rendering a comment and its nested replies
const CommentTree = ({ comment, user, replyToUUID, mode, onReplyCallback }) => {
          // const searchParams = useSearchParams()
          // useEffect(() => {
       
          // }, [])
 

    return (
        <div className={`mb-0 ${comment.parent_social_post_comment_uuid ? 'pl-4 bg-slate-100 dark:bg-slate-700' : ''}`}>
            <SocialPostSmallCard
            callback={onReplyCallback}
               replyToUUID = {replyToUUID}
                isNestedComment={!!comment.parent_social_post_comment_uuid}
                parentComponent={mode === "MODAL" ? "THREAD" : "PAGE"}
               // parentComponent={'THREAD'}
                user={user}
                key={comment.social_post_comment_uuid}
                data={comment}
            />

            {comment.replies && comment.replies.length > 0 &&
                (comment.replies.map(reply => (
                    <CommentTree
                      onReplyCallback={onReplyCallback}
                     mode={mode} replyToUUID={replyToUUID} key={reply.social_post_comment_uuid} comment={reply} user={user} />
                )))
            }
        </div>
    );
};










const SocialPostThreadModal = ({post, user, socialPostsCommentsTable, mainSocialPostCardIsClickable=false, postLimit, mode='MODAL'}) => {

  const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, thisUser, setSuccess, setError } = useContext(UIContext);
  const { scrollingUp, scrollingDown } = useContext(ScrollContext);

  const [editingPost, setEditingPost] = useState(false)
  const [shareModalOpen, setShareModalOpen] = useState(false)
  // console.log("SOCIALPOSTCOMMENTSTABLE", socialPostsCommentsTable)
  const searchParams = useSearchParams()
  const textareaRef = useRef(null);

  // const params = useParams()

  const focusTextarea = () => {
    textareaRef.current?.focus();
  };

  const params = new URLSearchParams(searchParams.toString())

  /*-------------------------------------
  Same methods as in SocialSmallCard.js
  -------------------------------------*/
  // unique to this page, this is not repeated in SocialSmallCard.js
  const parentComponent = mode === 'MODAL' ? 'THREAD' : 'PAGE'
  const data = post

  const handlePostUpvote = async (e) => {
    e.stopPropagation()
    if (!user) {
      setError({message: 'Please sign in'})
    }
     try {
     //    ?id=${target.id}
    //  let apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}`
          let apiUrl = `/api/social/reactions?user_type=${user.user_type}`


          let response = await fetch(apiUrl, {
          method: 'POST', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: {
            reaction_type: 'UPVOTE', 
            reaction_target_type: data.social_post_uuid ? 'SOCIAL_POST' : 'SOCIAL_COMMENT',
            reaction_target_uuid: data.social_post_uuid ? data.social_post_uuid : data.social_post_comment_uuid,
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleUpvoteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The post has been upvoted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error}`})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
}

  const handleDeleteUpvote = async (e) => {
    e.stopPropagation()
        try {
      //    ?id=${target.id}
      let apiUrl;
      if (parentComponent === 'THREAD') { // in post thread - deleting comment
        apiUrl = `/api/social/reactions/${data.social_post_comment_uuid}?user_type=${user.user_type}&record_type=COMMENT`
      }
      else { // in all posts (social) - deleting post
        apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
      }

            let response = await fetch(apiUrl, {
            method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            },
            credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
            // body: data
          });

          response = await response.json()
          console.log('handleDeleteResponse', response)
        if (response.success === true ) {
          // setSuccess({message: 'The post has been deleted.'})
          router.refresh()
      //    setLoading(false)
        }
        else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
      //    setLoading(false)
        }
        // callback({refreshData: true})

              
          } catch (error) {
            console.log('error', error)
            // setLoading(false)
          }
  }

  const handlePostEdit = async () => {
    setEditingPost(true)
    params.set('editing', 'true') // for the sake of completeness, post edit does not depend on this. We only use ?editing=true as a flag when hitting edit button from main social feed
    router.push(`?${params.toString()}`) // for the sake of completeness, post edit does not depend on this. We only use ?editing=true as a flag when hitting edit button from main social feed
  }

  const handleRespond = async (e) => {
        // unique to this page, this is not repeated in SocialSmallCard.js
        focusTextarea()


    // e.preventDefault()
      // e.stopPropagation()
    if (parentComponent === 'THREAD'){ // in root comment thread, this becomes a reply to a comment
        router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
        // router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}
        // &reply-to-handle=${data.user_data.user_handle}`, undefined, {shallow:true, scroll:false})
    }
    else if (parentComponent === 'PAGE'){ // from /social/[post]/page.js
      router.push(`?reply-to-uuid=${data.social_post_comment_uuid}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    }
    else if (parentComponent === 'INDEX') { // in all posts, this becomes a root comment to a post (we're attaching social/ to searchParams)
      router.push(`social?thread=${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
    }
    // else if (parentComponent === 'PAGE') { // from social/[post]/page.js
    //   router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    // }
    else { // in all posts, this becomes a root comment to a post
      router.push(`?thread=${data.social_post_uuid}#${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
      // #data.socialpostuuid prevents page from jumping up here
    }
  }

  // unused
  // const handleNewSocialPostCardCallback = cb => {
  //   console.log("CB", cb)
  //   if (cb.switchToTimelessBool){
  //   const params = new URLSearchParams(searchParams.toString())
  //   params.set("switchToTimeless", String(cb.switchToTimelessBool))
  //   router.push(`?${params.toString()}`)
  //   // window.history.replaceState(
  //   //     null,
  //   //     "",
  //   //     `${window.location.pathname}?${params.toString()}`
  //   // );
  //   }
  // }



     // // comments that commented on another comment
     // let replyComments = []

     // // comments that commented directly on the post
     // const rootComments = socialPostsCommentsTable.filter(comment => {
     //      // separate root from reply comments
     //      if (comment.parent_social_post_comment_uuid){
     //           replyComments.push(comment)
     //      }
     //      else {
     //           return !comment.parent_social_post_comment_uuid 
     //      }
     // })

     // let rootCommentsEnrichedWithReplies = []
     // console.log('replyComments', replyComments)
     // for (let rootComment of rootComments) {
     //      for (let replyComment of replyComments){
     //           if (replyComment.parent_social_post_comment_uuid === rootComment.social_post_comment_uuid){
     //                rootCommentsEnrichedWithReplies.push({
     //                     ...rootComment,
     //                     replies: replyComment
     //                })
     //           }
     //      }
     // }
 
     // console.log("ROOTCOMMENTSENRICHED", rootCommentsEnrichedWithReplies)


     


     // console.log("ROOTCOMMENTS", rootComments)
     
     const [replyToUUID, setReplyToUUID] = useState(searchParams.get('reply-to-uuid'))
     const [replyToHandle, setReplyToHandle] = useState(searchParams.get('reply-to-handle'))
      // const [replyToUserUUID, setReplyToUserUUID] = useState(searchParams.get('reply-to-user-uuid'))
     // console.log('post', post)
     const router = useRouter()
     useEffect(() => {
          setReplyToUUID(searchParams.get('reply-to-uuid'))
          setReplyToHandle(searchParams.get('reply-to-handle'))
          // setReplyToUserUUID(searchParams.get('reply-to-user-uuid'))
     }, [searchParams, replyToHandle])

     
    //  detect editing from searchParams and setEditingPost accordingly
    useEffect(() => {
      setEditingPost(Boolean(searchParams.get('editing')))
    }, [searchParams])
    
     if (post)
     return (


<div className="h-full flex flex-col">

  {/* Sticky header */}
  
    <div className={`px-2 dark:text-slate-400 sticky top-0 z-30 bg-slate-50 dark:bg-slate-800 border-b dark:border-slate-700 opacity-95 flex justify-between py-1 ${mode === 'MODAL' && 'pl-4 pr-2'} gap-4`}>
      {/* <Link
        href="/feed"
        className="flex items-center h-14 flex gap-4"
      >
          <div className="hover:text-teal-400 transition-all duration-150 rounded-full h-10 w-10 bg-slate-100 dark:bg-slate-700 flex items-center justify-center">
        <i className="text-base fa-solid fa-arrow-left-long" />
        </div>
        <span className="text-lg">Feed</span>
      </Link> */}

      <RoundButton caption={'Feed'} iconClassName={'fa-solid fa-arrow-left-long'} href={`/feed${searchParams.get('thread') ? `#${searchParams.get('thread')}` : ''}`}/>


      <div className="hidden text-sm 2xl:flex items-center">
        <h1>
        {post.social_post_title || ''}
        </h1>
      </div>


      <div className="flex gap-1 items-center">


        {/* <ArrowUpButton disabled={post.status === 'ARCHIVED'} onClick={e=>handlePostUpvote(e)} caption={post.reactions_count} reacted={post.reacted_by_me}/> */}
        <ArrowUpButton disabled={post.status === 'ARCHIVED'} onClick={e=>post.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={post.reactions_count} reacted={post.reacted_by_me}/>
        <CommentButton disabled={false} onClick={e=>handleRespond(e)} caption={post.comments_count || post.replies?.length || 0}/>
        <CopyUrlButton disabled={post.status === 'ARCHIVED'} 
    onClick={e=>{
    navigator.clipboard.writeText(`https://talnet.co/posts/${post.is_timeless ? post.social_post_url : post.social_post_url_short}`); e.stopPropagation(); setSuccess({message: 'Post url copied'})}} reacted={post.reacted_by_me}/>

      {/* <div onClick={()=>setShareModalOpen(true)}>Share</div> */}
      <MultipurposeOvalButton onClick={()=>setShareModalOpen(true)} purpose={'share'}/>

{(user?.user_uuid === post.social_post_user_uuid || user?.user_roles.role === 'ROOT') && mode !=='MODAL' && <>
<div className="border-r border-slate-200 dark:border-slate-700 h-8"></div>
    {editingPost === false && <EditButton disabled={post.status === 'ARCHIVED'} onClick={handlePostEdit}  active={editingPost}/>}
    {editingPost === true && <ConfirmOrCancelButton confirmOrCancel="CANCEL" 
    onClick={()=>{
      setEditingPost(false);
      params.delete("editing");
      router.replace(`?${params.toString()}`);
      // router.push(`?${params.toString()}`) 
  }}
    />}
</>
      }



    </div>
    </div>
  



  {/* SCROLL CONTAINER (header must be inside this parent) */}
  <div className="flex-1 overflow-y-auto overflow-x-hidden">
    {editingPost ? <NewSocialPostCard
    callback={cb=> setEditingPost(Boolean(cb.editing))}
    rounded={false}
    showTopicLevelsTooltip={true}
      ref={textareaRef}
        user={user}
        isComment
        replyToUUID={replyToUUID}
        // parentPost={post}
        replyToHandle={replyToHandle}
        target={post}
        // callback={handleNewSocialPostCardCallback}
        // mode={'EDIT'}
      /> : 
    <SocialPostSmallCard cardIsClickable={mainSocialPostCardIsClickable} callback={focusTextarea} data={post} user={user} parentComponent={mode === 'MODAL' ? 'THREAD' : 'PAGE'} />
    }

    {socialPostsCommentsTable?.[0]?.comments?.map(rootComment => (
      <CommentTree
      onReplyCallback={focusTextarea}
        mode={mode}
        key={rootComment.social_post_comment_uuid}
        replyToUUID={replyToUUID}
        comment={rootComment}
        user={user}
      />
    ))}
  </div>

  {/* Bottom input */}
  {/* {console.log("POST", post)} */}
  {/*  {post.user_data.user_uuid !== 'DELETED' && editingPost === false &&  */}
{editingPost === false && (
  // Logged-out users always see the join prompt
  !user ? (
    <div className="border-t dark:border-slate-700 px-2 duration-300 py-4 bg-slate-50 dark:bg-slate-900 sticky bottom-0 w-full">
      <div className="flex flex-col 3xl:flex-row gap-4 justify-between items-center">
        <div>
          <p className="font-medium">
            Want to join the conversation?
          </p>
          <p className="text-sm text-slate-500">
            Comment, react, and connect with recruiters and employers on Talnet.
          </p>
        </div>

        <div>
          <Link
            href="/auth/signup"
            className="text-sm relative px-4 py-2 rounded-lg text-white bg-teal-500 border-4 border-teal-300 duration-500 hover:bg-teal-600"
          >
            Join Talnet - it's free
          </Link>
        </div>
      </div>
    </div>
  ) : (
    // Logged-in users see the comment box only if permitted
    post.user_data?.user_uuid !== 'DELETED' &&
    post.user_data?.organization_uuid !== 'DELETED' &&
    (
      post.is_commentable === true ||
      user.user_uuid === post.social_post_user_uuid ||
      user.user_roles?.role === 'ROOT'
    ) && (
      <div
        className={`border-t dark:border-slate-700 px-2 duration-300 py-4 bg-slate-50 dark:bg-slate-900 sticky bottom-0 w-full
          ${parentComponent !== 'THREAD' && scrollingDown ? 'translate-y-full' : 'translate-y-0'}
        `}
      >
        <NewSocialPostCard
          ref={textareaRef}
          user={user}
          isComment
          replyToUUID={replyToUUID}
          parentPost={post}
          replyToHandle={replyToHandle}
        />
      </div>
    )
  )
)}





      <ShareModal captionToShare={post.is_timeless ? post.social_post_title : post.social_post_body.substring(0, 100) + '...'} hrefToShare={`https://talnet.co/posts/${post.is_timeless ? post.social_post_url : post.social_post_url_short}`} modalHeaderCaption={'Share this post'} state={{shareModalOpen, setShareModalOpen}} target={post}/>
</div>




          // v2 
//           <div className="h-full flex flex-col">
//                <div className="">
//           {/* Modal header */}
//           {mode === 'MODAL' 
//           ? 
//           <ModalHeader closeOnClickMethod={() => router.push('?')} /> 
//           :
//              <div className="sticky top-0 z-20 bg-slate-50 dark:bg-slate-900 border-b dark:border-slate-700">
//       <Link
//         href="/social"
//         className="pl-4 flex items-center h-14 text-2xl text-teal-400 hover:text-teal-300"
//       >
//         <i className="text-xl mr-2 fa-solid fa-arrow-left-long" />
//         <span>Feed</span>
//       </Link>
//     </div>
//                }
//                </div>
//                {/* <div className="-mt-6">
//                     <SocialPostSmallCard data={post} user={user} />
//                     </div> */}


//           {/* Scrollable comments */}
//           <div className="flex-1 overflow-y-auto pb-24">
//                <SocialPostSmallCard data={post} user={user} />
//           {socialPostsCommentsTable?.[0]?.comments?.length > 0 &&
//                socialPostsCommentsTable[0].comments.map(rootComment => (
//                <CommentTree
//                     replyToUUID={replyToUUID}
//                     key={rootComment.social_post_comment_uuid}
//                     comment={rootComment}
//                     user={user}
//                />
//                ))}
//           </div>

//           {/* Always visible input at bottom */}
//           {post.user_data.user_uuid !== 'DELETED' && <div className="px-2 py-4 dark:bg-transparent border-t dark:border-t-slate-700 pb-2">
//           <NewSocialPostCard
//                user={user}
//                isComment={true}
//                replyToUUID={replyToUUID}
//                parentPost={post}
//                replyToHandle={replyToHandle}
//           />
//           </div>}
//           </div>













          // <div className="h-screen flex flex-col">
          //      <ModalHeader closeOnClickMethod={()=>router.push('?')}/>
          //      <div className="flex-1 overflow-y-auto mb-0 px-2">
          //           {/* <SocialPostSmallCard data={post} user={user} parentComponent={'THREAD'}/> */}

          //          <div>
          //           {

          //                socialPostsCommentsTable?.[0]?.comments?.length > 0 &&
          //                socialPostsCommentsTable[0].comments.map(rootComment => (
          //                <CommentTree
          //                          replyToUUID={replyToUUID}
          //                     key={rootComment.social_post_comment_uuid}
          //                     comment={rootComment}
          //                     user={user}
          //                />
          //                ))

          //           }
          //           </div>
          //           <div className="fixed bottom-0 left-0 right-0 px-2 py-2 bg-white dark:bg-slate-900 border-t z-50">
          //           <NewSocialPostCard user={user} isComment={true} isNestedComment={replyToUUID} parentPost={post}/>
          //           </div>
          //      </div>
          // </div>
     )
}    

export default SocialPostThreadModal